// App Routes
export const CALCULATOR_PATH = ''

// Interal API Route
export const API_BASE_PATH = ``
export const API_CONTACT_PATH = `/calculator/api/contact`
export const API_TRACKING_PATH = `/calculator/api/tracking`

// API Routes
export const API_CALCULATORS_PATH = '/manager/calculators'
export const API_PACKS_PATH = `${API_CALCULATORS_PATH}/packs`
export const API_COUNTRIES_PATH = `hotel/countries`

// External Routes
export const CT_BASE_PATH = 'https://climatetrade.com'
export const CT_MARKET_BASE_PATH = 'https://market.climatetrade.com'
export const CT_ACCOUNT_PATH = `${CT_BASE_PATH}/accounts`
export const CT_SUMMARY_PATH = `${CT_ACCOUNT_PATH}/summary`
export const CT_TRANSACTIONS_PATH = `${CT_ACCOUNT_PATH}/my-orders`
export const CT_MY_PROJECTS_PATH = `${CT_ACCOUNT_PATH}/my-projects`
export const CT_NOTIFICATIONS_PATH = `${CT_ACCOUNT_PATH}/notifications`
export const CT_MESSAGES_PATH = `${CT_ACCOUNT_PATH}/messages`
export const CT_OFFERS_PATH = `${CT_ACCOUNT_PATH}/offers`
export const CT_MY_FOOTPRINT_PATH = `${CT_ACCOUNT_PATH}/my-footprint`
export const CT_RESULTS_PATH = `${CT_MARKET_BASE_PATH}/results`

export const EXTERNAL_LOGIN_PATH = `${CT_MARKET_BASE_PATH}/accounts/auth/login`
export const EXTERNAL_REGISTER_PATH = `${CT_MARKET_BASE_PATH}/accounts/auth/register`

// Tracking API Routes
export const TRACKING_VISITORS_PATH = '/v1/visitors'
export const TRACKING_VISITORS_EVENT_PATH = `${TRACKING_VISITORS_PATH}/add_track_event/`
